import { atomFamily, selectorFamily } from 'recoil'

import { MESSAGE_STR_TYPE_CONTENTSCAMPAIGN } from 'Constants'

export const messageDetailsState = atomFamily({
  key: 'messageDetailsState',
  default: {
    error: undefined,
    loading: false,
    loaded: false,
    id: undefined,
    idList: undefined,
    subject: undefined,
    note: undefined,
    size: undefined,
    published: undefined,
    archived: undefined,
    lastUpdated: undefined,
    tags: [],
    isBee: undefined,
    serviceType: undefined,
    hasThumbnail: undefined,
    messageType: undefined,
    creationDate: undefined,
    campaign: undefined
  }
})

export const canSendState = selectorFamily({
  key: 'messageDetailsCanSendState',
  get: idMessage => ({ get }) => {
    const { messageType } = get(messageDetailsState(idMessage))

    return messageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN
  }
})

export const canCodeReviewState = selectorFamily({
  key: 'messageDetailsCanCoreReviewState',
  get: idMessage => ({ get }) => {
    const { id, isBee } = get(messageDetailsState(idMessage))

    return id && !isBee
  }
})
